.form {
  float: left;
  width: 100%;
}

.form-sub-title {
  font-size: 1.2rem !important;
  font-weight: 300 !important;
  margin-top: 0.25rem !important;
}

.form-error {
  color: red;
}

.buttons {
  margin-top: 1rem;
}

.button {
  margin-top: 1rem;
  width: 49%;
}

.filePicker {
  position: relative;
  cursor: pointer;
  overflow: hidden;
}

.filePickerPreview {
  position: absolute;
  top: 0.6rem;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 1rem;
  z-index: 2;
  overflow: hidden;
  width: 150%;
}
.filePickerPreview img {
  float: left;
  height: 100%;
  margin-right: 0.5rem;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvZGV2L3NyYy9jYXB0dXJlbGlmZS9yZXBvcy9DYXB0dXJlbGlmZS1hd3MvcHdhL3NyYy9hcHBzL3BvcnRhbC9jb21wb25lbnRzL0Zvcm0iLCJzb3VyY2VzIjpbImNsYXNzZXMubW9kdWxlLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtFQUNBOzs7QUFNRjtFQUNFO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBO0VBQ0EiLCJzb3VyY2VzQ29udGVudCI6WyIuZm9ybSB7XG4gIGZsb2F0OiBsZWZ0O1xuICB3aWR0aDogMTAwJTtcbn1cblxuLmZvcm0tdGl0bGUge1xufVxuXG4uZm9ybS1zdWItdGl0bGUge1xuICBmb250LXNpemU6IDEuMnJlbSAhaW1wb3J0YW50O1xuICBmb250LXdlaWdodDogMzAwICFpbXBvcnRhbnQ7XG4gIG1hcmdpbi10b3A6IDAuMjVyZW0gIWltcG9ydGFudDtcbn1cblxuLmZvcm0tZXJyb3Ige1xuICBjb2xvcjogcmVkO1xufVxuXG4uYnV0dG9ucyB7XG4gIG1hcmdpbi10b3A6IDFyZW07XG59XG5cbi5idXR0b24ge1xuICBtYXJnaW4tdG9wOiAxcmVtO1xuICB3aWR0aDogNDklO1xufVxuXG4uZmlsZVBpY2tlciB7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgY3Vyc29yOiBwb2ludGVyO1xuICBvdmVyZmxvdzogaGlkZGVuO1xufVxuXG4uZmlsZVBpY2tlclByZXZpZXcge1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHRvcDogMC42cmVtO1xuICBsZWZ0OiAwO1xuICByaWdodDogMDtcbiAgYm90dG9tOiAwO1xuICBwYWRkaW5nOiAxcmVtO1xuICB6LWluZGV4OiAyO1xuICBvdmVyZmxvdzogaGlkZGVuO1xuICB3aWR0aDogMTUwJTtcblxuICBpbWcge1xuICAgIGZsb2F0OiBsZWZ0O1xuICAgIGhlaWdodDogMTAwJTtcbiAgICBtYXJnaW4tcmlnaHQ6IDAuNXJlbTtcbiAgfVxufVxuIl19 */